/**
 * Shared Modal Components
 *
 * Unified modal components for consistent UX across the application.
 * All modals follow the same prop interface and accessibility standards.
 *
 * @example Import base modal
 * ```tsx
 * import { BaseModal } from '@/components/shared/modals';
 * ```
 *
 * @example Import specialized modal
 * ```tsx
 * import { ConfirmationModal, FormModal } from '@/components/shared/modals';
 * ```
 */

// Base components
export { BaseModal,  } from './BaseModal';
export { AlertModal,  } from './AlertModal';

// Specialized components
export { ConfirmationModal,   } from './ConfirmationModal';
export { FormModal,  } from './FormModal';

// Re-export constants for convenience
export {
  MODAL_SIZES,
  MODAL_HEIGHTS,
  
  
} from '@/components/shared/modal-sheet-constants';
